import * as yup from 'yup';

import i18n from '@app/i18n/config';

export const stringSchema = (requiredErrorText?: string) => {
  const commonRequiredText = i18n.t('COMMON:errors.required');

  return yup
    .string()
    .required(requiredErrorText || commonRequiredText)
    .test(
      'not-only-whitespace',
      requiredErrorText || commonRequiredText,
      (value: string | undefined) => !!value?.trim()
    );
};
